export const UNIT_ROLES = {
  UNIT_OWNER: 'unit_owner',
  UNIT_TENANT: 'unit_tenant',
  UNIT_RESIDENT: 'unit_resident',
};

export const UNIT_ROLES_LABELS = {
  [UNIT_ROLES.UNIT_OWNER]: 'Unit Owner',
  [UNIT_ROLES.UNIT_TENANT]: 'Unit Tenant',
  [UNIT_ROLES.UNIT_RESIDENT]: 'Unit Resident',
};

export const UNIT_ROLES_DESCRIPTIONS = {
  [UNIT_ROLES.UNIT_OWNER]: 'Owns the unit',
  [UNIT_ROLES.UNIT_TENANT]: 'Rents the unit',
  [UNIT_ROLES.UNIT_RESIDENT]: 'Lives in the unit',
};
